import React from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import {
  NavLinkClickHandler,
  NavMenuDropdownProps,
} from "src/assets/Types/Redesign/PrimaryNavMenuType.type";
import { CtaButton } from "@components/RedesignComponents/Cta/cta-button";

const FeaturesHeader: React.FC<
  Omit<NavMenuDropdownProps, "categoryList"> & NavLinkClickHandler
> = ({ copy, image, imageAltText, textLinks, onClickHandler, title }) => {
  return (
    <header className="font-sans bg-sun-300 w-full rounded-3xl flex flex-row min-h-[173px] mx-auto items-center justify-between">
      <div className="flex flex-col gap-6 justify-center self-stretch py-6 px-12 w-1/2">
        <div className="flex flex-col gap-2">
          <h5 className="font-[450] text-2xl leading-[30px] -tracking-[0.24px] text-forest-900">
            {title}
          </h5>
          <p
            className={`text-sm leading-[165%] text-forest-900 font-normal `}
            id="copyContainer"
          >
            {copy}
          </p>
        </div>
        <div className={`flex flex-row gap-6 `}>
          {textLinks?.map(({ linkCopy, page, url }, key) => (
            <NavigationMenu.Link asChild key={key}>
              <CtaButton
                variant="tertiaryForest"
                onClick={e => onClickHandler(e, { category: "features" })}
                link={(page || url) as string}
                copy={linkCopy}
                copySize="bodyRegular"
                hasAnimation={true}
              />
            </NavigationMenu.Link>
          ))}
        </div>
      </div>
      <div className="flex h-full w-1/2">
        <img
          className="rounded-e-3xl bg-cover bg-center bg-no-repeat h-full w-full"
          src={image}
          alt={imageAltText}
        />
      </div>
    </header>
  );
};

export default FeaturesHeader;
